export default "__VITE_ASSET__BeSbWTXW__"